interface AgentLineDialogueProps extends React.SVGProps<SVGSVGElement> {
  /** 切换为带星星的对话气泡变体（claw light 模式使用）。 */
  withStar?: boolean;
}

export const AgentLineDialogue = ({ withStar = false, ...props }: AgentLineDialogueProps) => {
  if (withStar) {
    return (
      <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M18.6 12.5C18.6 16.92 15.02 20.5 10.6 20.5C9.51 20.5 8.48 20.28 7.53 19.89C7.04 19.69 6.58 19.44 6.15 19.15C6 19.05 5.08 19.23 3.39 19.7C3.85 18.01 4.03 17.09 3.94 16.95C3.65 16.52 3.4 16.06 3.2 15.57C2.81 14.62 2.6 13.59 2.6 12.5C2.6 8.08 6.18 4.5 10.6 4.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M15.84 3.45C15.92 3.15 16.34 3.15 16.42 3.45L16.77 4.83C16.97 5.6 17.57 6.2 18.34 6.4L19.72 6.75C20.02 6.83 20.02 7.25 19.72 7.33L18.34 7.68C17.57 7.88 16.97 8.48 16.77 9.25L16.42 10.63C16.34 10.93 15.92 10.93 15.84 10.63L15.49 9.25C15.29 8.48 14.69 7.88 13.92 7.68L12.54 7.33C12.24 7.25 12.24 6.83 12.54 6.75L13.92 6.4C14.69 6.2 15.29 5.6 15.49 4.83L15.84 3.45Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.0004 21.6004C17.3023 21.6004 21.6004 17.3023 21.6004 12.0004C21.6004 6.69845 17.3023 2.40039 12.0004 2.40039C6.69845 2.40039 2.40039 6.69845 2.40039 12.0004C2.40039 13.302 2.65943 14.5431 3.12878 15.675C3.3711 16.2594 3.66949 16.8146 4.01724 17.3341C4.13394 17.5084 3.915 18.6105 3.36039 20.6404C5.39026 20.0858 6.49234 19.8668 6.66668 19.9836C7.18613 20.3313 7.7414 20.6297 8.3258 20.872C9.45764 21.3413 10.6988 21.6004 12.0004 21.6004Z"
        fill="currentColor"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="12" fill="#1E2023" r="1.25" />
      <circle cx="7.66675" cy="12" fill="#1E2023" r="1.25" />
      <circle cx="16.3333" cy="12" fill="#1E2023" r="1.25" />
    </svg>
  );
};
